import { Dialog, DialogContent } from "@/components/ui/dialog";

export default function VideoModal({ open, onClose, url, title }) {
    return (
        <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
            <DialogContent className="max-w-5xl bg-black border-white/20 p-0 overflow-hidden" data-testid="video-modal">
                <div className="p-4 border-b border-white/10">
                    <div className="chapter-num">Now Playing</div>
                    <div className="font-mono uppercase text-lg mt-1">{title}</div>
                </div>
                <div className="bg-black aspect-video">
                    {url && (
                        <video src={url} controls autoPlay className="w-full h-full" data-testid="modal-video" />
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}
